export enum HgSessionStorageKey {
  SESSION_ID = 'sessionId',
  H3_REACHABLE_CELLS = 'h3ReachableCells',
}
